import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Flex, Box } from 'grid-styled';

import ModalSelect from './ModalSelect';
import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';

import Background from '../assets/alert-circle.png';

class StreamEncoderModal extends Component {
    componentDidMount() {}

    validateModel = () => {
        const { model } = this.props;

        let validationVariable = model.validateModelByModal('encoder');

        let validationObject = {};

        if (validationVariable.length > 0) {
            for (let i = 0; i < validationVariable.length; i++) {
                validationObject[validationVariable[i]] = model.validate(
                    validationVariable[i]
                );
            }

            this.props.updateState({
                formErrors: validationObject,
                formValid: false
            });
        } else {
            for (let i = 0; i < validationVariable.length; i++) {
                validationObject[validationVariable[i]] = model.validate(
                    validationVariable[i]
                );
            }

            this.props.updateState({
                formErrors: validationObject,
                formValid: true
            });
        }
    };

    getBitrateValues = () => {
        // STEREO INPUT
        if (
            this.props.model['inputchannel'] === 'stereo' &&
            this.props.model['encodertype'] === 'aac'
        ) {
            // 32khz
            if (this.props.model['samplingrate'] === '32000') {
                return ['16000', '64000'];
            }

            // 44.1khz
            if (this.props.model['samplingrate'] === '44100') {
                return ['40000', '64000', '128000', '192000'];
            }

            // 48khz
            if (this.props.model['samplingrate'] === '48000') {
                return ['64000', '96000', '128000', '192000'];
            }
        }

        if (
            this.props.model['inputchannel'] === 'stereo' &&
            this.props.model['encodertype'] === 'mp3'
        ) {
            // 44.1khz
            if (this.props.model['samplingrate'] === '44100') {
                return ['64000', '128000'];
            }

            // 48khz
            if (this.props.model['samplingrate'] === '48000') {
                return ['128000', '192000'];
            }
        }

        // MONO Input
        if (
            (this.props.model['inputchannel'] === 'mono-left' ||
                this.props.model['inputchannel'] === 'mono-right') &&
            this.props.model['encodertype'] === 'aac'
        ) {
            // 22.05khz
            if (this.props.model['samplingrate'] === '22050') {
                return ['10000'];
            }

            // 32khz
            if (this.props.model['samplingrate'] === '32000') {
                return ['16000', '48000'];
            }

            // 44.1khz
            if (this.props.model['samplingrate'] === '44100') {
                return ['32000', '96000'];
            }

            // 48khz
            if (this.props.model['samplingrate'] === '48000') {
                return ['40000', '56000', '128000'];
            }
        }

        if (
            (this.props.model['inputchannel'] === 'mono-left' ||
                this.props.model['inputchannel'] === 'mono-right') &&
            this.props.model['encodertype'] === 'mp3'
        ) {
            // 22.05khz
            if (this.props.model['samplingrate'] === '22050') {
                return ['32000'];
            }

            // 24khz
            if (this.props.model['samplingrate'] === '24000') {
                return ['48000'];
            }

            // 44.1khz
            if (this.props.model['samplingrate'] === '44100') {
                return ['64000', '128000'];
            }

            // 48khz
            if (this.props.model['samplingrate'] === '48000') {
                return ['128000', '192000'];
            }
        }

        return [
            '32000',
            '64000',
            '96000',
            '128000',
            '160000',
            '192000',
            '224000',
            '320000'
        ];
    };
    getBitrateLabels = () => {
        // STEREO INPUT
        if (
            this.props.model['inputchannel'] === 'stereo' &&
            this.props.model['encodertype'] === 'aac'
        ) {
            // 32khz
            if (this.props.model['samplingrate'] === '32000') {
                return ['16 kb/s', '64 kb/s'];
            }

            // 44.1khz
            if (this.props.model['samplingrate'] === '44100') {
                return ['40 kb/s', '64 kb/s', '128 kb/s', '192 kb/s'];
            }

            // 48khz
            if (this.props.model['samplingrate'] === '48000') {
                return ['64 kb/s', '96 kb/s', '128 kb/s', '192 kb/s'];
            }
        }

        if (
            this.props.model['inputchannel'] === 'stereo' &&
            this.props.model['encodertype'] === 'mp3'
        ) {
            // 44.1khz
            if (this.props.model['samplingrate'] === '44100') {
                return ['64 kb/s', '128 kb/s'];
            }

            // 48khz
            if (this.props.model['samplingrate'] === '48000') {
                return ['128 kb/s', '192 kb/s'];
            }
        }

        // MONO Input
        if (
            (this.props.model['inputchannel'] === 'mono-left' ||
                this.props.model['inputchannel'] === 'mono-right') &&
            this.props.model['encodertype'] === 'aac'
        ) {
            // 22.05khz
            if (this.props.model['samplingrate'] === '22050') {
                return ['10 kb/s'];
            }

            // 32khz
            if (this.props.model['samplingrate'] === '32000') {
                return ['16 kb/s', '48 kb/s'];
            }

            // 44.1khz
            if (this.props.model['samplingrate'] === '44100') {
                return ['32 kb/s', '96 kb/s'];
            }

            // 48khz
            if (this.props.model['samplingrate'] === '48000') {
                return ['40 kb/s', '56 kb/s', '128 kb/s'];
            }
        }

        if (
            (this.props.model['inputchannel'] === 'mono-left' ||
                this.props.model['inputchannel'] === 'mono-right') &&
            this.props.model['encodertype'] === 'mp3'
        ) {
            // 22.05khz
            if (this.props.model['samplingrate'] === '22050') {
                return ['32 kb/s'];
            }

            // 24khz
            if (this.props.model['samplingrate'] === '24000') {
                return ['48 kb/s'];
            }

            // 44.1khz
            if (this.props.model['samplingrate'] === '44100') {
                return ['64 kb/s', '128 kb/s'];
            }

            // 48khz
            if (this.props.model['samplingrate'] === '48000') {
                return ['128 kb/s', '192 kb/s'];
            }
        }

        return [
            '32 kb/s',
            '64 kb/s',
            '96 kb/s',
            '128 kb/s',
            '160 kb/s',
            '192 kb/s',
            '224 kb/s',
            '320 kb/s'
        ];
    };

    render() {
        const { model, updateState, statevariable } = this.props;

        return (
            <Box>
                <Flex>
                    <Box w={2 / 3}>
                        <ModalSelect
                            label="Encoder Type"
                            model={model}
                            name="encodertype"
                            updateState={updateState}
                            statevariable={statevariable}
                            validateModel={this.props.validateModel}
                            errormask={statevariable.formErrors.encodertype}
                            background={Background}
                            optionsValue={['mp3', 'aac']}
                            optionsName={['MP3', 'AAC']}
                        />
                        <ModalSelect
                            label="Bitrate Type"
                            model={model}
                            name="bitratetype"
                            updateState={updateState}
                            statevariable={statevariable}
                            errormask={statevariable.formErrors.bitratetype}
                            validateModel={this.props.validateModel}
                            background={Background}
                            optionsValue={['CBR', 'VBR']}
                            optionsName={['CBR', 'VBR']}
                        />

                        <ModalSelect
                            label="Bitrate"
                            model={model}
                            name="bitrate"
                            updateState={updateState}
                            statevariable={statevariable}
                            errormask={statevariable.formErrors.bitrate}
                            validateModel={this.props.validateModel}
                            background={Background}
                            optionsValue={this.getBitrateValues()}
                            optionsName={this.getBitrateLabels()}
                        />
                    </Box>
                    <BoxTemplate
                        textalign="left"
                        mr={'15px'}
                        ml={'15px'}
                        w={1 / 3}
                    >
                        <Label textStyle="labelSmall">
                            <b>Encoder type</b>
                            <br />
                            Select encoding (data) format. The formats are: MP3,
                            AAC.
                            <br />
                            <b>Bitrate Type</b>
                            <br />
                            There are two bitrate types you can choose from: CBR
                            and VBR.
                            <p>
                                CBR stands for "Constant Bit Rate" and uses the
                                entire given bit rate
                            </p>
                            <p>
                                VBR stands for "Variable Bit Rate" and optimizes
                                the use of the bandwidth by requiring more or
                                less bandwith depending on the complexity of the
                                music.
                            </p>
                            <b>Bitrate</b>
                            <br />
                            The audio compression level (and consequently the
                            audio quality) is selected by the 'bitrate' field.
                            Select the audio bit rate in kilobits per second.
                            Please note that depending on the sampling rate,
                            defined in the 'input values' step, not all bitrates
                            are available.
                        </Label>
                    </BoxTemplate>
                </Flex>
            </Box>
        );
    }

    checkarray(value, array) {
        let i = array.indexOf(value);
        if (i > -1) {
            return true;
        } else {
            return false;
        }
    }
}

export default inject('model')(observer(StreamEncoderModal));



// WEBPACK FOOTER //
// ./src/form/StreamEncoderModal.js